// extracted by mini-css-extract-plugin
module.exports = {"PowerPlantSectionA":"PowerPlantSectionA_PowerPlantSectionA__GsmuF"};